import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { ConnectedRouter } from 'connected-react-router'
import { Layout, Row, Col } from 'antd'
import routes from '../routes'
import Sidebar from '../components/Sidebar'
import 'react-table/react-table.css'
import { isLogin } from '../modules/Authentication';
import GlobalHistory from '../modules/History';

class App extends Component {
  constructor() {
    super();
    this.authenticationController = this.authenticationController.bind(this);

  }

  componentDidMount() {
    this.authenticationController();
  }

  componentDidUpdate() {
    this.authenticationController();
  }

  shouldComponentUpdate() {
    this.authenticationController();
  }

  authenticationController() {
    if (!isLogin()) {
      this.props.history.push(`/login`);
    }
  }

  render() {
    this.authenticationController();
    const { Content } = Layout;
    const { history } = this.props;
    GlobalHistory.item = history;
    return (
      <div className="app-root" style={{ textAlign: 'right', direction: 'rtl' }}>
        <Row>

          <Col sm={20}>
            <Content style={{ padding: '40px 0' }}>
              <ConnectedRouter history={history}>
                {routes}
              </ConnectedRouter>
            </Content>
          </Col>
          <Col span={4}>
            <Sidebar history={history} />
          </Col>
        </Row>

      </div> 
    )
  } 
}

App.propTypes = {
  history: PropTypes.object.isRequired
}

export default App



// WEBPACK FOOTER //
// ./src/containers/App.js